import { z } from 'zod';
import { isAllowedPurchaseOrderDocumentFile } from '@/features/purchase-order/lib/purchase-order-document-allowed-files';

export type PurchaseOrderDocumentFormValues = {
  documentTypeId: string;
  file: File | undefined;
};

type purchaseOrderDocumentFormSchemaParams = {
  requireDocumentType: boolean;
};

export const purchaseOrderDocumentFormSchema = ({
  requireDocumentType,
}: purchaseOrderDocumentFormSchemaParams) => {
  let schema = z
    .object({
      documentTypeId: z.string(),
      file: z.custom<File | undefined>(
        (v) => v === undefined || v instanceof File,
      ),
    })
    .refine((data) => data.file instanceof File, {
      message: 'documentsFormFileRequired',
      path: ['file'],
    })
    .refine(
      (data) =>
        !(data.file instanceof File) ||
        isAllowedPurchaseOrderDocumentFile(data.file),
      {
        message: 'documentsFormFileTypeInvalid',
        path: ['file'],
      },
    )
    .refine(
      (data) =>
        !(data.file instanceof File) || data.file.size <= 20 * 1024 * 1024,
      {
        message: 'documentsFormFileMaxSize',
        path: ['file'],
      },
    );

  if (requireDocumentType) {
    schema = schema.refine((data) => data.documentTypeId.trim().length > 0, {
      message: 'documentsFormDocumentTypeRequired',
      path: ['documentTypeId'],
    });
  }

  return schema;
};
